import PrebuiltBetBuilderImpl from './prebuilt-bet-builder.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetBuilder view that renders prebuilt bet builder card.
 *
 * @class PrebuiltBetBuilder
 * @memberof Mojito.Modules
 */

/**
 * Prebuilt bet prop types.
 *
 * @property {object} event - ID to populate data with (top leagues or all leagues).
 * @property {object} market - ID to populate data with (top leagues or all leagues).
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 *
 * @memberof Mojito.Modules.PrebuiltBetBuilder
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
};

export default UIView('PrebuiltBetBuilder', PrebuiltBetBuilderImpl, propTypes);
